import { PiColumnsPlusRight } from 'react-icons/pi'

import { Button } from '~/components/Buttons'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { joinClassNames } from '~/helpers'

import styles from './styles.module.css'

const ToggleButton: React.FC<ToggleButtonProps> = ({
  onClick,
  disabled = false,
  className
}) => {
  const { t } = useAPPTranslation()

  return (
    <Button
      className={joinClassNames(styles.button, className)}
      disabled={disabled}
      iconLeft={
        <PiColumnsPlusRight aria-hidden="true" className={styles.icon} />
      }
      onClick={onClick}
      size="small"
      template="tertiary"
      text={t('c:components.ColumnSelector.columns')}
      type="button"
    />
  )
}

export default ToggleButton
